import { render, staticRenderFns } from "./EditVoucherData.vue?vue&type=template&id=08b6e5cd&"
import script from "./EditVoucherData.vue?vue&type=script&lang=js&"
export * from "./EditVoucherData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports